<template>
  <div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.mainProgram') }}
        <i
          class="fas fa-question-circle"
          v-tooltip="
            $t(
              'school.payment.setup.feeSetup.chooseMainProgramToFilterSubProgram'
            )
          "
        ></i>
        <i class="fa fa-spinner spin" v-if="main_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.acp_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('acp_id') }"
          @change="fetchSubProgram(model.acp_id)"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(main, index) in mainPrograms"
            :key="index"
            :value="main.acp_id"
          >
            {{ main.acp_name_foreign }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('acp_id')">
          {{ errors.first('acp_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.subProgram') }}
        <i
          class="fas fa-question-circle"
          v-tooltip="
            $t('school.payment.setup.feeSetup.chooseSubProgramToFilterLevel')
          "
        ></i>
        <i class="fa fa-spinner spin" v-if="sub_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.acps_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('acps_id') }"
          @change="fetchLevel(model.acps_id)"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(sub, index) in subPrograms"
            :key="index"
            :value="sub.acps_id"
          >
            {{ sub.acps_name_foreign }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('acps_id')">
          {{ errors.first('acps_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.level') }}
        <i
          class="fas fa-question-circle"
          v-tooltip="
            $t('school.payment.setup.feeSetup.chooseLevelToFilterGrade')
          "
        ></i>
        <i class="fa fa-spinner spin" v-if="level_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.level_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('level_id') }"
          @change="fetchGrade(model.level_id)"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(level, index) in levels"
            :key="index"
            :value="level.level_id"
          >
            {{ level.level_name_foreign }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('level_id')">
          {{ errors.first('level_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.grade') }}
        <span class="validate" v-if="isTuitionFee || isStudyMaterialFee"
          >*</span
        >
        <i class="fa fa-spinner spin" v-if="grade_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.grade_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('grade_id') }"
          @change="onChangeGrade($event)"
        >
          <option value>{{ $t('select') }}</option>
          <option v-for="(g, index) in grades" :key="index" :value="g.grade_id">
            {{ g.grade_name_foreign }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('grade_id')">
          {{ errors.first('grade_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group" v-if="!isStudyMaterialFee">
      <label
        class="col-md-4 col-form-label"
        :class="{ required: isTuitionFee }"
        >{{ $t('school.payment.setup.feeSetup.paymentTerm') }}</label
      >
      <div class="col-md-8">
        <select
          v-model="model.payment_term_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('payment_term_id')
          }"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(p, index) in paymentTerm"
            :key="index"
            :value="p.payment_term_id"
          >
            {{ p.payment_term }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('payment_term_id')">
          {{ errors.first('payment_term_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group" v-if="isTuitionFee || isStudyMaterialFee">
      <label class="col-md-4 col-form-label required">{{
        $t('school.payment.setup.feeSetup.session')
      }}</label>
      <div class="col-md-8">
        <select
          v-model.number="model.session_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('session_id')
          }"
        >
          <option :value="null">{{ $t('select') }}</option>
          <option
            v-for="(session, index) in sessions"
            :key="index"
            :value="session.session_id"
          >
            {{ session.session_name }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('session_id')">
          {{ errors.first('session_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group" v-if="!isStudyMaterialFee">
      <label
        class="col-md-4 col-form-label">{{ $t('school.payment.setup.feeSetup.shift') }}</label
      >
      <div class="col-md-8">
        <select
          v-model="model.shift_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('shift_id')
          }"
        >
          <option value>{{ $t('select') }}</option>
          <option v-for="(s, index) in shifts" :key="index" :value="s.shift_id">
            {{ s.shift_en }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('shift_id')">
          {{ errors.first('shift_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group" v-if="isStudyMaterialFee">
      <label class="col-md-4 col-form-label">{{
        $t('school.payment.setup.feeSetup.applyFor')
      }}</label>
      <div class="col-md-8">
        <select class="form-control" v-model.number="model.new_old_status_id">
          <option value="0">{{ $t('feesetup.all') }}</option>
          <option value="1">{{ $t('feesetup.oldStudent') }}</option>
          <option value="2">{{ $t('feesetup.newStudent') }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'academicFeeSetup',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      subPrograms: [],
      levels: [],
      grades: [],
      main_fetch: false,
      sub_fetch: false,
      level_fetch: false,
      grade_fetch: false
    }
  },
  created() {
    this.model = this.value
    this.fetchProgram()
    this.getPaymentTerm()
    this.getSession()
    this.getShift()
    this.setEditData()
  },
  computed: {
    ...mapState('feeSetup', [
      'mainPrograms',
      'edit_data',
      'paymentTerm',
      'sessions',
      'shifts'
    ]),
    isNotEdit() {
      if (_.isEmpty(this.edit_data)) {
        return true
      }
      return false
    },
    isTuitionFee() {
      return this.model.fee_type_id == 1
    },
    isServiceFee() {
      return this.model.fee_type_id == 2
    },
    isBusFee() {
      return this.model.fee_type_id == 3
    },
    isStudyMaterialFee() {
      return this.model.fee_type_id == 4
    },
    isOtherMaterialFee() {
      return this.model.fee_type_id == 5
    },
    isOtherFee() {
      return this.model.fee_type_id == 6
    }
  },
  methods: {
    ...mapActions('feeSetup', ['getPaymentTerm', 'getSession', 'getShift']),
    onChangeGrade: function(e) {
      if (e.target.value) {
        this.model.fee_name_en =
          e.target.options[e.target.options.selectedIndex].text
      } else {
        this.model.fee_name_en = ''
      }
    },
    fetchProgram() {
      this.subPrograms = []
      this.levels = []
      this.grades = []
      this.main_fetch = true
      this.$store.dispatch('feeSetup/getMainProgram').finally(() => {
        this.main_fetch = false
      })
    },
    fetchSubProgram(mainId) {
      this.model.acps_id = this.isNotEdit ? '' : this.model.acps_id
      this.model.level_id = this.isNotEdit ? '' : this.model.level_id
      this.model.grade_id = this.isNotEdit ? '' : this.model.grade_id
      this.subPrograms = []
      this.levels = []
      this.grades = []
      if (mainId) {
        this.sub_fetch = true
        this.$store
          .dispatch('feeSetup/getSubProgram', mainId)
          .then(response => {
            this.subPrograms = response.data
          })
          .finally(() => {
            this.sub_fetch = false
          })
      }
    },
    fetchLevel(acps_id) {
      this.model.grade_id = this.isNotEdit ? '' : this.model.grade_id
      this.model.level_id = this.isNotEdit ? '' : this.model.level_id
      this.levels = []
      this.grades = []
      if (acps_id) {
        this.level_fetch = true
        this.$store
          .dispatch('feeSetup/getLevel', acps_id)
          .then(response => {
            this.levels = response.data
          })
          .finally(() => {
            this.level_fetch = false
          })
      }
    },
    fetchGrade(level_id) {
      this.model.grade_id = this.isNotEdit ? '' : this.model.grade_id
      this.grades = []
      if (level_id) {
        this.grade_fetch = true
        this.$store
          .dispatch('feeSetup/getGrade', level_id)
          .then(response => {
            this.grades = response.data
          })
          .finally(() => {
            this.grade_fetch = false
          })
      }
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.fetchSubProgram(this.model.acp_id)
        this.fetchLevel(this.model.acps_id)
        this.fetchGrade(this.model.level_id)
      }
    }
  },

  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>
